import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ToggleField = ({
  className = '',
  inputClassName = '',
  meta = {},
  errorMessage = '',
  attributes = {},
  input = {},
  firstOption = {},
  secondOption = {},
  errorPositionedClassName
}) => {
  const { error, submitFailed } = meta;
  const toggleFieldClassNames = classNames('ToggleField ', className);
  const errorClassNames = classNames('error text-danger text-small', errorPositionedClassName);

  return (
    <div className={ toggleFieldClassNames } {...attributes}>
      <input
        {...input}
        type="radio"
        id={firstOption.id}
        className={classNames('switch-input', inputClassName)}
        checked={input.value === firstOption.value}
        disabled={input.value === firstOption.value}
        value={firstOption.value}
        {...firstOption.attributes}
      />
      <label
        className="switch-label switch-label-on"
        htmlFor={firstOption.id}
        id={`${firstOption.id}-label`}
      >
        {firstOption.label}
      </label>
      <input
        {...input}
        type="radio"
        id={secondOption.id}
        className={classNames('switch-input', inputClassName)}
        checked={input.value === secondOption.value}
        disabled={input.value === secondOption.value}
        value={secondOption.value}
        {...secondOption.attributes}
      />
      <label
        className="switch-label switch-label-off"
        htmlFor={secondOption.id}
        id={`${secondOption.id}-label`}
      >
        {secondOption.label}
      </label>
      {
        (error && submitFailed) && (
          <p className={errorClassNames}>
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

ToggleField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  firstOption: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.node,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    attributes: PropTypes.object
  }),
  secondOption: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.node,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    attributes: PropTypes.object
  }),
  input: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.string,
  errorPositionedClassName: PropTypes.string
};

ToggleField.defaultProps = {
  errorPositionedClassName: ''
}

export default ToggleField;
